// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__arWMI","ActionBox":"styles_ActionBox__93cRz"};